import { useTheme } from "@emotion/react";
import {
	Button,
	Chip,
	Modal,
	Paper,
	TextField,
	Typography,
} from "@mui/material";
import useStyles from "./styles";
import { Box } from "@mui/system";
import StyledRatingComponent from "../../styledRatingComponent";
import { useEffect, useState } from "react";
import RatingWoman from "../../../components/artsPersonComponent/ratingWoman";

export default function ModalAvaliacaoComponent(params) {
	const {
		open,
		handleClose = () => {},
		questions = [],
		createAnswerForm = () => {},
		formId,
		ticketId,
	} = params;
	const theme = useTheme();
	const styles = useStyles(theme);

	const [optionsSelecionada, setOptionsSelecionada] = useState([]);
	const [rating, setRating] = useState([]);
	const [answerComment, setAnswerComment] = useState([]);
	const handleDirect = () => {
		createAnswerForm(
			rating,
			optionsSelecionada,
			answerComment,
			formId,
			"",
			ticketId
		);
		handleClose();
	};

	const toggleSelecionado = (option) => {
		setOptionsSelecionada((prevSelecionados) => {
			const jaSelecionado = prevSelecionados?.some(
				(item) => item?.id === option?.id
			);

			if (jaSelecionado) {
				return prevSelecionados?.filter((item) => item?.id !== option?.id);
			} else {
				return [...prevSelecionados, option];
			}
		});
	};

	const handleComentarioChange = (questionId, novoComentario) => {
		setAnswerComment((prev) => {
			const existe = prev?.find((item) => item?.questionId === questionId);

			if (existe) {
				// Atualiza o comentário existente
				return prev?.map((item) =>
					item?.questionId === questionId
						? { ...item, answer: novoComentario }
						: item
				);
			} else {
				// Adiciona novo comentário
				return [...prev, { questionId, answer: novoComentario }];
			}
		});
	};

	return (
		<>
			<Modal
				open={open}
				onClose={handleClose}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
			>
				<Box sx={styles.containerModal}>
					<RatingWoman
						backgroundFill={theme.palette.tertiary.medium}
						circleFill={theme.palette.background.paper}
					/>
					<Box sx={styles.boxComponent}>
						<Typography
							sx={{ fontSize: "22px", fontWeight: "bold", textAlign: "center" }}
						>
							Avalie o seu atendimento!
						</Typography>
					</Box>
					<Paper variant="outlined" sx={{ overflowY: "auto", height: "310px" }}>
						{Array.isArray(questions) &&
							questions?.length > 0 &&
							questions?.map((question, index) => (
								<Box sx={styles.containerQuestion}>
									<Box sx={styles.containerDescriptionQuestion}>
										<Typography sx={{}}>
											{index + 1} - {question?.question}
										</Typography>
									</Box>

									{question?.type === 0 && (
										<StyledRatingComponent
											setRating={setRating}
											questionId={question?.id}
											rating={rating}
										/>
									)}

									{question?.type === 1 && (
										<TextField
											sx={{ width: "100%" }}
											id="outlined-multiline-static"
											label="Comentário"
											multiline
											rows={3}
											value={
												answerComment?.find((c) => c.questionId === question.id)
													?.answer || ""
											}
											onChange={(e) =>
												handleComentarioChange(question.id, e.target.value)
											}
										/>
									)}
									{question?.type === 2 && (
										<Paper variant="outlined" sx={styles.containerChipsSelect}>
											{question?.options?.map((option) => {
												const selecionado = optionsSelecionada?.some(
													(item) => item?.id === option?.id
												);

												return (
													<Chip
														key={option.id}
														label={option.option}
														size="small"
														clickable
														onClick={() => toggleSelecionado(option)}
														color={selecionado ? "primary" : "default"}
														variant={selecionado ? "filled" : "outlined"}
													/>
												);
											})}
										</Paper>
									)}
								</Box>
							))}
					</Paper>
					<Box sx={styles.containerButtons}>
						<Button onClick={handleClose} variant="text">
							Cancelar
						</Button>
						<Button onClick={() => handleDirect()} variant="contained">
							Enviar
						</Button>
					</Box>
				</Box>
			</Modal>
		</>
	);
}
